import { render } from "./Button.vue?vue&type=template&id=379bcace&scoped=true&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=379bcace&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379bcace"]])

export default __exports__